import * as React from 'react'
import { FlatList, View } from 'react-native'
import styled from '@theme/styled-components'

import Checkbox from '@components/checkbox/Checkbox'

import useReducer from '@store/useReducer'
import { ResultStore } from '@screens/incident/IncidentListScreen'

import useI18n from '@i18n/useI18n'

import { COLORS, ICONS, IncidentTypeEnum } from '@components/incidentStatus/IncidentStatus'

import { EtatWorkflowIncidentEnum } from '@api/enum'

interface Props {
  selected: EtatWorkflowIncidentEnum[]
  onStatusSelected: (items: EtatWorkflowIncidentEnum[]) => void
}

const DATA: EtatWorkflowIncidentEnum[] = [
  EtatWorkflowIncidentEnum.EN_ATTENTE_DE_VALIDATION,
  EtatWorkflowIncidentEnum.EN_ATTENTE_DE_PRISE_EN_CHARGE,
  EtatWorkflowIncidentEnum.REFUS_PRESTATAIRE,
  EtatWorkflowIncidentEnum.EN_COURS_DE_TRAITEMENT,
  EtatWorkflowIncidentEnum.EN_PAUSE,
  EtatWorkflowIncidentEnum.ABANDONNEE,
  EtatWorkflowIncidentEnum.CLOTUREE_PRESTATAIRE,
  EtatWorkflowIncidentEnum.CLOTUREE_VIPARIS,
  EtatWorkflowIncidentEnum.EN_ATTENTE_DE_DEVIS,
  EtatWorkflowIncidentEnum.DEVIS_ENVOYE,
]

const StatusInlineFilter = ({ selected, onStatusSelected }: Props) => {
  const i18n = useI18n()

  const incidents = useReducer(ResultStore, (s) => s)

  const data = React.useMemo(
    () =>
      DATA.map((p) => ({
        label: i18n.t(`incidentStatus.${p}`),
        value: p,
        count: incidents.filter((inc) => inc.status === p).length,
      })).sort((a, b) => a.label.localeCompare(b.label)),
    [DATA, incidents]
  )

  const onItemSelected = (item: EtatWorkflowIncidentEnum) => {
    const isSelected = selected.includes(item)

    onStatusSelected(isSelected ? selected.filter((id) => id !== item) : [...selected, item])
  }

  const renderItem = ({ item }: { item: { label: string; value: EtatWorkflowIncidentEnum; count: number } }) => {
    const isSelected = selected.includes(item.value)

    return (
      <Item>
        <Checkbox
          iconOnTheRight
          label={item.label}
          onClick={() => onItemSelected(item.value)}
          value={isSelected}
          icon={{ name: ICONS[item.value as IncidentTypeEnum], color: COLORS[item.value].light }}
          info={item.count > 0 ? item.count : undefined}
        />
      </Item>
    )
  }

  const onSelectAll = () => {
    if (allSelected) {
      onStatusSelected([])
    } else {
      onStatusSelected(data.map((d) => d.value))
    }
  }

  const allSelected = data.every((st) => selected.includes(st.value))

  return (
    <>
      <ChecklistItem>
        <Checkbox
          label={i18n.t('common.selectAll')}
          value={allSelected}
          onClick={onSelectAll}
          iconOnTheRight
          fontBold
        />
      </ChecklistItem>
      <FlatList
        data={data}
        keyExtractor={(item) => JSON.stringify(item.value)}
        renderItem={renderItem}
        extraData={selected}
      />
    </>
  )
}

export default StatusInlineFilter

const Item = styled(View)`
  padding: 5px 0;
`

const ChecklistItem = styled(Item)`
  margin: 5px 0 12px 24px;
`
